type BrandLogoProps = {
  large?: boolean;
  className?: string;
  onLight?: boolean;
};

export function BrandLogo({ large = false, className = "", onLight = false }: BrandLogoProps) {
  return <div className={["brand-logo", large ? "large" : "", onLight ? "on-light" : "", className].filter(Boolean).join(" ")}>
    <img src="/vl-logo-organize.png?v=1.4.0" alt="virtualMedica · Organize" />
  </div>;
}
